module.exports = __webpack_public_path__ + "img/image4.70ecf075.png";